import { useEffect, useState } from 'react'

// eslint-disable-next-line no-unused-vars
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import Isotope from 'isotope-layout'
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'

function Portfolio() {
    const {data :{home: {portfolio : {data,name}}},isLoading} = useGetSettingQuery()
    let uniq

    // state for storing the isotope object, with an initial value of null
    const [isotope, setIsotope] = useState(null);
    // state for storing the filter keyword, with an initial value of *, which matches everything
    const [filterKey, setFilterKey] = useState('*');
    const [loaded, setLoaded] = useState(false);
    
    useEffect(() => {
        setIsotope(
          new Isotope('.portfolio-container', {
            // filter-container: className of the parent of the isotope elements
            itemSelector: '.portfolio-item', // filter-item: className of the isotope elements
            layoutMode: 'fitRows', // for horizontal isotope
            percentPosition: true,
            resizesContainer: true,
            originLeft: false
          })
        );
      }, []);

      useEffect(() => {
        if (isotope) {
          // sanity check
          filterKey === '*'
            ? isotope.arrange({ filter: `*` })
            : isotope.arrange({ filter: `.${filterKey}` });
        }
      }, [isotope, filterKey]);

      function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
      }

      if(data.lso_portfos) {
        let cats = data.lso_portfos.map((row,index) => {return row.txt_category.replace(/\s+/g, '-').toLowerCase()} )

        uniq = cats.filter(onlyUnique)
      }   

      if(isLoading)
        return <p>در حال بارگذاری</p>
      else 
        return ( 
        <div className="container-xxl py-5" id='portfolio'>
            <div className="container">
                <div className="section-title text-center">
                    <h1 className="display-5 mb-5">{name}</h1>
                </div>
                <div className="row mt-n2 wow fadeInUp" data-wow-delay="0.3s">
                    <div className="col-12 text-center">
                        <ul className="list-inline mb-5" id="portfolio-flters">
                            <li className={`mx-2 ${filterKey === '*' && 'active'}`} onClick={() => setFilterKey('*')}>همه</li>
                            {uniq && uniq.map((row,index) => 
                                <li key={index} className={`mx-2 ${filterKey === row && 'active'}`} onClick={() => setFilterKey(row)}>{row}</li>
                            )}
                        </ul>
                    </div>
                </div>
                <div className="row g-4 portfolio-container">
                    {data.lso_portfos && data.lso_portfos.map((row,index) => 
                    <div className={`col-lg-4 col-md-6 portfolio-item ${row.txt_category.replace(/\s+/g, '-').toLowerCase()} wow fadeInUp`} data-wow-delay="0.1s" key={index}>
                        <div className="rounded overflow-hidden">
                            <div className="position-relative overflow-hidden">
                                <img className="img-fluid w-100" style={loaded ? {} : {minHeight:"310px"}} src={row.img_image} alt={row.txt_title} onLoad={() => setLoaded(true)}/>
                                <div className="portfolio-overlay">
                                    <div className="btn btn-square btn-outline-light mx-1" data-src={row.img_image} data-fancybox data-caption={row.txt_title}><i className="fa fa-eye"></i></div>
                                    <a className="btn btn-square btn-outline-light mx-1" href={row.lnk_link}><i className="fa fa-link"></i></a>
                                </div>
                            </div>
                            <div className="border border-5 border-light border-top-0 p-4">
                                <h5 className="text-primary fw-medium mb-2">{row.txt_title}</h5>
                                <p className="lh-base mb-0">{row.txe_description}</p>
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>
     );
}

export default Portfolio;